import React from 'react';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import dayjs from 'dayjs';

const formatTime = (iso) => {
	const d = dayjs(iso);
	return d.isValid() ? d.format('h:mm A') : '';
};

const AssignmentChip = ({
	assignment,
	onClick,
	showPerson = false,
	compact = false,
}) => {
	const theme = useTheme();
	const timeLabel = `${formatTime(assignment.starts_at)}-${formatTime(
		assignment.ends_at,
	)}`;
	const title = showPerson
		? assignment.user_name || 'Crew'
		: assignment.job_name || 'Job';

	return (
		<Box
			component="button"
			type="button"
			onClick={(event) => {
				event.stopPropagation();
				onClick?.(assignment);
			}}
			sx={{
				display: 'block',
				width: '100%',
				textAlign: 'left',
				border: 'none',
				cursor: onClick ? 'pointer' : 'default',
				borderRadius: 1.5,
				px: 1,
				py: compact ? 0.5 : 0.75,
				mb: 0.5,
				backgroundColor: alpha(theme.palette.primary.main, 0.12),
				color: theme.palette.text.primary,
				'&:hover': onClick
					? {
							backgroundColor: alpha(theme.palette.primary.main, 0.2),
						}
					: undefined,
				'&:focus-visible': {
					outline: `2px solid ${theme.palette.primary.main}`,
					outlineOffset: 1,
				},
			}}
		>
			<Typography
				variant="caption"
				sx={{
					display: 'block',
					fontWeight: 700,
					lineHeight: 1.25,
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
				}}
			>
				{title}
			</Typography>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: 'block', lineHeight: 1.2 }}
			>
				{timeLabel}
			</Typography>
		</Box>
	);
};

export default AssignmentChip;
